import { BookOpenCheck, Search } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";

import { request } from "../api";
import { ErrorCard, Loading } from "../components/AsyncState";
import type { UserLexeme } from "../types";
import { errorMessage, vocabStatusLabel } from "../utils";

export function VocabularyPage() {
  const [items, setItems] = useState<UserLexeme[] | null>(null);
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try {
      setItems(await request<UserLexeme[]>("/api/vocabulary?limit=500"));
      setError("");
    } catch (reason) {
      setError(errorMessage(reason));
    }
  }, []);
  useEffect(() => void load(), [load]);
  const filtered = useMemo(
    () => (items ?? []).filter((item) => item.lexeme.lemma.includes(query.toLowerCase())),
    [items, query]
  );

  if (error) return <ErrorCard message={error} retry={() => void load()} />;
  if (!items) return <Loading label="正在打开个人词汇表" />;

  return (
    <div className="stack">
      <header className="page-heading">
        <div><span className="eyebrow"><BookOpenCheck size={14} /> Vocabulaire</span><h1>个人词汇模型</h1><p>一个词条是一组 lemma + 词性；具体义项和用法仍由上下文标记承载。</p></div>
      </header>
      <label className="search-field"><Search size={18} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="搜索 lemma" /></label>
      {filtered.length ? (
        <div className="vocab-table">
          <div className="vocab-table__head"><span>词条</span><span>状态</span><span>证据</span><span>模型概率</span></div>
          {filtered.map((item) => (
            <article key={item.lexeme.id}>
              <div><strong>{item.lexeme.lemma}</strong><small>{item.lexeme.upos.toLowerCase()} · Zipf {item.lexeme.zipf_frequency?.toFixed(1) ?? "—"}</small></div>
              <span className={`vocab-state vocab-state--${item.receptive_status}`}>{vocabStatusLabel[item.receptive_status] || item.receptive_status}</span>
              <span>{item.evidence_count} 条</span>
              <div className="probability"><i style={{ width: `${item.receptive_probability * 100}%` }} /><span>{Math.round(item.receptive_probability * 100)}%</span></div>
            </article>
          ))}
        </div>
      ) : (
        <div className="empty-state"><BookOpenCheck size={34} /><h3>{query ? "没有匹配词条" : "词汇表正在等待证据"}</h3><p>测试、预习判断和阅读标记都会逐步写入这里。</p></div>
      )}
    </div>
  );
}
